import { useEffect, useRef } from "react";
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

export const ChartSellIn = ({ data, isHorizontal }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) chartInstance.current.destroy();

    const ctx = chartRef.current.getContext("2d");

    const formattedData = {
      labels: data?.map(item => item.title),
      datasets: [
        {
          axis: "y",
          label: "Total",
          data: data?.map(item => item.total),
          backgroundColor: "#156082",
          borderColor: "#156082",
          minBarLength: 8,
          borderRadius: 0,
          barPercentage: 0.5,
        },
      ],
    };

    const config = {
      type: isHorizontal ? "horizontalBar" : "bar",
      plugins: [ChartDataLabels],
    };

    const options = {
      indexAxis: "y",
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      layout: {
        padding: {
          top: 25,
          right: isHorizontal ? 40 : 25,
          left: 25,
        },
      },
      plugins: {
        datalabels: {
          anchor: "end",
          align: "end",
          color: "#000",
          font: {
            size: 12,
          },
          formatter: function (_value, context) {
            return data[context.dataIndex].datalabel;
          },
        },
      },
      scales: {
        yAxes: [
          {
            display: isHorizontal,
            gridLines: {
              display: false,
            },
            ticks: {
              callback: function (label) {
                if (String(label).length > 20) {
                  return label.slice(0, 20) + "...";
                }
                return label;
              },
            },
          },
        ],
        xAxes: [
          {
            display: !isHorizontal,
            gridLines: {
              display: false,
            },
            ticks: {
              autoSkip: false,
              maxRotation: 40,
              minRotation: 40,
            },
          },
        ],
      },
    };

    chartInstance.current = new Chart(ctx, {
      data: formattedData,
      options: options,
      ...config,
    });

    return () => {
      if (chartInstance.current) chartInstance.current.destroy();
    };
  }, [data, isHorizontal]);

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <canvas ref={chartRef}></canvas>
    </div>
  );
};
